var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('header-buttons',{attrs:{"buttons":_vm.headerButtons},on:{"onNewMatch":_vm.newMatch}}),_c('admin-matches-table',{on:{"onShow":_vm.show}}),_c('modal-update-password',{attrs:{"showModal":_vm.showModalUpdatePassword},on:{"updateShowModal":(value) => { _vm.showModalUpdatePassword = value }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }